import React, { FunctionComponent, useState } from 'react';
import { withApiData, ApiDataBinding } from 'react-api-data';
import { compose } from 'recompose';
import { withTranslation, WithTranslation } from 'react-i18next';

// constants
import { LinkFull } from 'constants/api';

// components
import FormModal from './FormModal';
import { connect } from 'react-redux';
import { archiveLinkAction } from 'redux/app/appActions';
import { Alert } from 'reactstrap';
import RolesChecker from 'components/utils/RolesChecker';
import { Roles } from 'constants/literals';

interface InputProps {
    uuid: string;
    exchange: string;
    xmlId: string;
    invalidateData: () => void;
}

interface EnhanceProps {
    archiveMemberLink: ApiDataBinding<{ data: LinkFull }>;
    removeLinkFromLinksHistory: (uuid: string) => void;
}

type Props = EnhanceProps & InputProps & WithTranslation;

const enhance = compose<Props, InputProps>(
    withApiData({
        archiveMemberLink: 'archiveMemberLink',
    }),
    withTranslation(),
    connect(null, (dispatch) => ({
        removeLinkFromLinksHistory: (linkUuid: string) => dispatch(archiveLinkAction({ linkUuid })),
    }))
);

const ConnectionDeleteModal: FunctionComponent<Props> = ({
    archiveMemberLink,
    removeLinkFromLinksHistory,
    invalidateData,
    uuid,
    exchange,
    xmlId,
    t,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }
    function onSubmit() {
        return archiveMemberLink.perform({
            linkUuid: uuid,
            exchange,
        });
    }

    function onSucces() {
        removeLinkFromLinksHistory(uuid);
        invalidateData();
    }

    return (
        <React.Fragment>
            <FormModal
                header={ t('archiveMemberLink.modalHeader', { xmlId }) }
                isOpen={isOpen}
                toggle={toggle}
                initialValues={{}}
                onSubmit={onSubmit}
                onSuccess={onSucces}
                successMessage={t('archiveMemberLink.successful')}
            >
                {() => (
                    <React.Fragment>
                        <Alert color="warning" className="mb-0">
                            <strong>{t('common.warning')}</strong>
                            <p>{t('archiveMemberLink.warningMessage')}</p>
                        </Alert>
                    </React.Fragment>
                )}
            </FormModal>
            <RolesChecker data-test="user-roles-checker" roles={[Roles.admin, Roles.noc]}>
                <span
                    data-test="Connection-delete-btn"
                    className="fas fa-trash fa-pull-left mt-1 text-primary cursor-pointer"
                    onClick={toggle}
                    title={t('archiveMemberLink.modalTitle')}
                />
            </RolesChecker>
        </React.Fragment>
    );
};

export default enhance(ConnectionDeleteModal);
